module.exports = __webpack_public_path__ + "img/public.1641d16a.svg";